
import Modal from "@/components/Modal.vue";
import AddFarmButton from "@/components/AddFarmButton.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { gettersInstance } from "@/lib/util";

const StoreGetters = gettersInstance(["hasOwnSeasons", "farmIds", "userEmail"]);

@Component({
  name: "DemoFarmModal",
  components: { AddFarmButton, Modal },
})
export default class DemoFarmModal extends mixins(MixedVue, StoreGetters) {
  static components: {
    AddFarmButton: typeof AddFarmButton;
    Modal: typeof Modal;
  };
  showModal = true;

  get showSecondParagraph() {
    return !this.userEmail || this.farmIds.length == 0 || !this.hasOwnSeasons;
  }
}
